const trialTableSaga = function* () {

};

export default trialTableSaga;
